<template>
  <div>
    <slot v-if="$slots.customTitle" name="customTitle" />
    <span v-else class="text-xs font-semibold uppercase"><slot name="default" /></span>
    <Divider class="my-1" />
  </div>
</template>

<script setup lang="ts">
import { Divider } from '../../../containers/divider';
</script>
